// extracted by mini-css-extract-plugin
export default {"btnContainer":"HhY7nTq1XNYUtxMDAio8__btnContainer___","editFrom":"C2bpYeDSu5APEbnhpgKG__editFrom___","externalLink":"reanGlA0kPY6onh3aLXr__externalLink___"};